import { Logo } from '@/components/Logo/Logo';

import { FooterCertifications } from '../FooterCertifications/FooterCertifications';
import { FooterStyle } from '../../LandingFooter';
import styles from './FooterTop.module.sass';

interface FooterTopProps {
  type?: FooterStyle;
}

export const FooterTop = ({ type }: FooterTopProps) => {
  const blackUnion = type === 'black' || type === 'black-transparent';

  const logoType = blackUnion ? 'white' : 'black';
  const certificationsColor = blackUnion ? 'white' : 'black';

  return (
    <div className={styles.top}>
      <div className={styles.info}>
        <div className={styles.logo}>
          <Logo type={logoType} className={styles.logoImg} />
        </div>

        <div className={styles.requisites}>
          <div className={styles.requisit}>
            <div className={styles.requisitTitle}>Global:</div>
            <p>
              <b>Safelement Limited,</b>
              <br />
              Office 1111, Suite 1102, Lee Garden One, 33 Hysan Avenue, Causeway
              Bay, Hong Kong
            </p>
          </div>

          <div className={styles.requisit}>
            <div className={styles.requisitTitle}>European Union:</div>
            <p>
              <b>Safe3 UAB</b>
              <br /> Registration code: 306141950
              <br />
              Address: Vilnius, J. Jasinskio g. 16B, LT-03163
            </p>
          </div>
        </div>
      </div>

      <div className={styles.right}>
        <FooterCertifications color={certificationsColor} />
      </div>
    </div>
  );
};
